
import {Component, Prop, Watch} from 'vue-property-decorator'
import BaseForm from '@/components/forms/BaseForm'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import CheckboxYesNo from '@/components/common/CheckboxYesNo.vue'
import {required} from 'vuelidate/lib/validators'
import SmsBlocTextModel from '@/models/SmsBlocTextModel'

@Component({
  components: {
    BaseFormContainer,
    CheckboxYesNo
  },
  validations: {
    form: {
      LIBELLE: {
        required
      },
      TEXTE: {
        required
      }
    }
  }
})
export default class SmsBlocTextForm extends BaseForm {
  model = SmsBlocTextModel
  countContentTextArea = 0

  @Watch('form.TEXTE', {deep: false})
  watchContentTextArea(val: any) {
    this.countContentTextArea = val.length
  }
}
